import { QUERY_shiftModalOrderDetails } from 'queries';
import { UseGQLQueryConfig } from 'hooks/useGQLQuery/useGQLQuery.types';
import { ShiftModalOrderDetailsQuery } from 'types/graphql';
import { createApolloCache, createApolloClient } from 'providers/ApolloProvider';

const shiftModalApolloClient = createApolloClient({ cache: createApolloCache() });

export const openShiftModalDetailsQueryConfig = (
  facility_id: number,
  shift_id?: number,
): UseGQLQueryConfig<
  ShiftModalOrderDetailsQuery,
  ShiftModalOrderDetailsQuery,
  { id: number | undefined }
> => ({
  key: 'OPEN_SHIFT_MODAL_DETAILS_QUERY',
  query: QUERY_shiftModalOrderDetails,
  client: shiftModalApolloClient,
  variables: {
    id: shift_id,
  },
  context: {
    headers: {
      'USER-CURRENT-FACILITY-TYPE': 'Community',
      'USER-CURRENT-FACILITY-ID': facility_id,
    },
  },
});
